import React from 'react'

import Horizontal from '../layouts/Horizontal.jsx'
import Card from '../components/Card.jsx'
import WordCloud from '../components/WordCloud.jsx'
import ZeroState from '../components/ZeroState.jsx'
import useRect from '../hooks/useRect.js'

const CategoryCloud = (props) => {
  const { selected_entities, title, description, section_1 } = props.data

  const data = Object.fromEntries(selected_entities.map((entity) => [entity.key, entity.value]))

  const [Rect, rect] = useRect()

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      notes={section_1.footnote}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          <Rect />
          <ZeroState
            condition={selected_entities?.length >= 2}
            placeholder="Add at least 2 categories."
          >
            <WordCloud data={data} limit={25} height={rect.height} width={rect.width} y={0} />
          </ZeroState>
        </Card>
      )}
    />
  )
}

export default CategoryCloud
